import { call, put, takeEvery } from 'redux-saga/effects';
import { CoOpActionKeys, UpdateCoOpCampaignType } from '..';
import { ICoOpCampaignType, lookupActionCreators } from '../../lookups';
import { uiActionCreators } from '../../ui';
import * as api from '../coOpApi';

function* updateCoOpCampaignTypeSaga(action: UpdateCoOpCampaignType) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: ICoOpCampaignType = yield call(api.updateCoOpCampaignType, action.payload);

  yield put(lookupActionCreators.setLookups({ partial: true, payload: { coOpCampaignTypes: [response] } }));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpCampaignType() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_CAMPAIGN_TYPE, updateCoOpCampaignTypeSaga);
}
